import { render, staticRenderFns } from "./QuotationFormEdit.vue?vue&type=template&id=0f665f68&scoped=true&lang=html&"
import script from "./QuotationFormEdit.vue?vue&type=script&lang=js&"
export * from "./QuotationFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuotationFormEdit.vue?vue&type=style&index=0&id=0f665f68&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f665f68",
  null
  
)

export default component.exports